import React, { useEffect, useState } from 'react';
import { Button, Flex, Icon, Loading, Typo } from '../../../../ui';
import Results from '../../../Module/components/TaskModule/Results';
import Confetti from 'react-confetti';
import { useWindowSize } from 'react-use';
import { useTranslation } from 'react-i18next';

const ResultsScreen = ({ showParty, canShowResults, pageInfo, quizSettings, lastQuiz, handleStartQuiz, themeColor }) => {
  const { t } = useTranslation();
  const [results, setResults] = useState(null);
  const { width, height } = useWindowSize();

  useEffect(() => {
    const data = pageInfo.pageRows
      .flatMap((row) => row.pageModules)
      .map((pageModule) => {
        const {
          id,
          data: {
            params: { task, taskResults },
          },
        } = pageModule;
        return { ...task, pageModuleId: id, taskResults };
      });

    setResults(data);
  }, [pageInfo]);

  return !lastQuiz ? (
    <Loading themeColor={themeColor} />
  ) : (
    <>
      {lastQuiz.status === 'QUIZ_SUCCESS' && showParty && <Confetti width={width} height={height} />}
      <Icon.Questions size='xxl' color={themeColor} />
      <Typo.BigText>{lastQuiz.status === 'QUIZ_SUCCESS' ? quizSettings?.successText : quizSettings?.failText}</Typo.BigText>
      <Typo.TextTitle>
        {t('quiz.yourScore')}: {lastQuiz.score} / {lastQuiz.total}
      </Typo.TextTitle>
      {canShowResults && !!results && (
        <Flex direction='column' width='90%' align='stretch'>
          {results?.map(({ taskResults, pageModuleId, ...task }) => {
            if (!!taskResults.length)
              return (
                <div key={`${task.id}-${pageModuleId}`}>
                  <Typo.MediumText>{task.caption.main}</Typo.MediumText>
                  <Results
                    taskOptions={task.caption.items}
                    result={taskResults[taskResults.length - 1]}
                    taskType={task.type}
                    key={task.id}
                    explanation={task.caption?.comment}
                  />
                </div>
              );
            else return null;
          })}
        </Flex>
      )}
      {!!handleStartQuiz && (
        <Button $variant='customized' $bgcolor={themeColor} onClick={handleStartQuiz}>
          {t('quiz.restart')}
        </Button>
      )}
    </>
  );
};

export default ResultsScreen;
